import * as React from "react";
import { useCallback, useState } from "react";
import { useQueryClient } from "@tanstack/react-query";
import { ConfirmDialog, IfPermitted } from "components/common";
import UserNotification from "util/UserNotification";
import { DeleteMenuItem } from "components/bootstrap";
import StringUtils from "util/StringUtils";
import BulkActionsDropdown from "components/common/EntityDataTable/BulkActionsDropdown";
import useSelectedEntities from "components/common/EntityDataTable/hooks/useSelectedEntities";
import { COLLECTIONS_QUERY_KEY } from "collections/hooks/useCollections";
import useCollectionMutation from "collections/hooks/useCollectionMutation";
const getDescriptor = (count) => StringUtils.pluralize(count, "collection", "collections");
const BulkActions = () => {
  const { bulkDeleteCollectionsMutation } = useCollectionMutation();
  const queryClient = useQueryClient();
  const { selectedEntities, setSelectedEntities } = useSelectedEntities();
  const [showDialog, setShowDialog] = useState(false);
  const selectedItemsAmount = selectedEntities == null ? void 0 : selectedEntities.length;
  const refetchCollections = useCallback(
    () => queryClient.invalidateQueries({
      queryKey: [COLLECTIONS_QUERY_KEY]
    }),
    [queryClient]
  );
  const handleDelete = () => {
    setShowDialog(true);
  };
  const handleClearState = () => {
    setShowDialog(false);
    refetchCollections();
  };
  const onDelete = useCallback(() => {
    bulkDeleteCollectionsMutation.mutateAsync({ entityIds: selectedEntities }).then(({ failures }) => {
      if (failures == null ? void 0 : failures.length) {
        const notUpdatedCollectionIds = failures.map(({ entity_id }) => entity_id);
        setSelectedEntities(notUpdatedCollectionIds);
        UserNotification.error(
          `${notUpdatedCollectionIds.length} out of ${selectedItemsAmount} selected ${getDescriptor(selectedItemsAmount)} could not be deleted.`
        );
      } else {
        setSelectedEntities([]);
        UserNotification.success(
          `${selectedItemsAmount} ${getDescriptor(selectedItemsAmount)} ${StringUtils.pluralize(selectedItemsAmount, "was", "were")} deleted successfully.`,
          "Success"
        );
      }
    }).catch((error) => {
      UserNotification.error(`An error occurred while deletion collection. ${error}`);
    }).finally(() => {
      refetchCollections();
    });
  }, [bulkDeleteCollectionsMutation, refetchCollections, selectedEntities, selectedItemsAmount, setSelectedEntities]);
  const handleConfirm = () => {
    onDelete();
    setShowDialog(false);
  };
  return /* @__PURE__ */ React.createElement(React.Fragment, null, /* @__PURE__ */ React.createElement(BulkActionsDropdown, null, /* @__PURE__ */ React.createElement(IfPermitted, { permissions: selectedEntities.map((entityId) => `collections:delete:${entityId}`) }, /* @__PURE__ */ React.createElement(DeleteMenuItem, { onSelect: handleDelete }))), showDialog && /* @__PURE__ */ React.createElement(ConfirmDialog, { title: "Delete Collections", show: true, onConfirm: handleConfirm, onCancel: handleClearState }, "Are you sure you want to delete ", selectedItemsAmount, " ", getDescriptor(selectedItemsAmount), "?"));
};
export default BulkActions;
